// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile {
  background-color: var(--body_background);
}
.profile .images {
  width: 100%;
  height: 300px;
  position: relative;
}
.profile .images .cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.profile .images .profilePic {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 200px;
}
.profile .profileContainer {
  padding: 20px 70px;
}
.profile .profileContainer .uInfo {
  height: 180px;
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: var(--body_background);
  color: var(--body_color);
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.profile .profileContainer .uInfo .center {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  /* Dropdown button on hover & focus */
  /* The container <div> - needed to position the dropdown content */
  /* Dropdown Content (Hidden by Default) */
  /* Links inside the dropdown */
  /* Change color of dropdown links on hover */
  /* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */
}
.profile .profileContainer .uInfo .center span {
  font-size: 30px;
  font-weight: 500;
}
.profile .profileContainer .uInfo .center .info {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.profile .profileContainer .uInfo .center .info .item {
  display: flex;
  align-items: center;
  gap: 5px;
  color: var(--body_color);
}
.profile .profileContainer .uInfo .center .info .item span {
  font-size: 12px;
}
.profile .profileContainer .uInfo .center .toggleJobsAppliedTo {
  padding: 10px;
  border: none;
  background-color: var(--body_color);
  color: var(--body_background);
  font-weight: bold;
  cursor: pointer;
}
.profile .profileContainer .uInfo .center .myRequestsButton {
  border: none;
  background-color: var(--body_color);
  color: var(--body_background);
  cursor: pointer;
  display: inline-block;
  outline: 0;
  padding: 0 56px;
  height: 45px;
  line-height: 45px;
  border-radius: 7px;
  background-color: turquoise;
  font-weight: 400;
  font-size: 16px;
  box-shadow: 0 4px 14px 0 rgba(0, 118, 255, 0.39);
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}
.profile .profileContainer .uInfo .center .myRequestsButton :hover {
  background: rgba(0, 118, 255, 0.9);
  box-shadow: 0 6px 20px rgba(0, 118, 255, 0.23);
}
.profile .profileContainer .uInfo .center .recordedVideosButton {
  border: none;
  background-color: var(--body_color);
  color: var(--body_background);
  cursor: pointer;
  display: inline-block;
  outline: 0;
  padding: 0 56px;
  height: 45px;
  line-height: 45px;
  border-radius: 7px;
  background-color: tourquoise;
  font-weight: 400;
  font-size: 16px;
  box-shadow: 0 4px 14px 0 rgba(0, 118, 255, 0.39);
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}
.profile .profileContainer .uInfo .center .recordedVideosButton :hover {
  background: rgba(0, 118, 255, 0.9);
  box-shadow: 0 6px 20px rgba(0, 118, 255, 0.23);
}
.profile .profileContainer .uInfo .center .notificationsButton {
  position: fixed;
  top: 90px;
  right: 20px;
  background: none;
  border: none;
  padding: 5px;
  cursor: pointer;
}
.profile .profileContainer .uInfo .center .notificationsButton img {
  width: 30px;
  height: auto;
}
.profile .profileContainer .uInfo .center .notificationCount {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 5px;
  font-size: 12px;
}
.profile .profileContainer .uInfo .center .settingsbtn img {
  width: 30px;
  height: auto;
}
.profile .profileContainer .uInfo .center .settingsbtn {
  position: fixed;
  top: 140px;
  right: 20px;
  background: none;
  border: none;
  padding: 5px;
  cursor: pointer;
}
.profile .profileContainer .uInfo .center .dropdown {
  position: relative;
  display: inline-block;
}
.profile .profileContainer .uInfo .center .dropdown-content {
  display: none;
  position: fixed;
  top: 200px;
  right: 20px;
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.profile .profileContainer .uInfo .center .dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
.profile .profileContainer .uInfo .center .profilePic {
  justify-content: center;
  align-items: center;
}
.profile .profileContainer .uInfo .center .dropdown-content a:hover {
  background-color: #ddd;
}
.profile .profileContainer .uInfo .center .show {
  display: block;
}
.profile .jobsAppliedToContainer h1 {
  text-align: center;
  color: var(--body_color);
}`, "",{"version":3,"sources":["webpack://./src/pages/Profile/profile.scss"],"names":[],"mappings":"AAEA;EACI,wCAAA;AADJ;AAII;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAFN;AAKM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAHR;AAMM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AAJR;AAOI;EACE,kBAAA;AALN;AAQM;EACE,aAAA;EAGA,kDAAA;EACA,mBAAA;EACA,wCAAA;EACA,wBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AANR;AAYQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EA2HA,qCAAA;EAGV,kEAAA;EAMA,yCAAA;EAYA,8BAAA;EAgBA,4CAAA;EAGA,qIAAA;AAvKA;AAMU;EACE,eAAA;EACA,gBAAA;AAJZ;AAOU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AALZ;AAOY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;AALd;AAOc;EACE,eAAA;AALhB;AAUU;EACE,aAAA;EACA,YAAA;EACA,mCAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AARZ;AAWU;EACE,YAAA;EACA,mCAAA;EACA,6BAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,gDAAA;EACA,uEAAA;AATZ;AAWA;EACE,kCAAA;EACA,8CAAA;AATF;AAaU;EACE,YAAA;EACA,mCAAA;EACA,6BAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,gDAAA;EACA,uEAAA;AAXZ;AAaA;EACE,kCAAA;EACA,8CAAA;AAXF;AAeU;EACG,eAAA;EACA,SAAA;EACD,WAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAbZ;AAiBU;EACE,WAAA;EACA,YAAA;AAfZ;AAkBU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAhBZ;AAmBU;EACE,WAAA;EACA,YAAA;AAjBZ;AAqBU;EACE,eAAA;EACA,UAAA;EACD,WAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAnBX;AA0BA;EACE,kBAAA;EACA,qBAAA;AAxBF;AA4BA;EACE,aAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,+CAAA;EACA,UAAA;AA1BF;AA8BA;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AA5BF;AA+BA;EACE,uBAAA;EACA,mBAAA;AA7BF;AAoCA;EAA2B,sBAAA;AAjC3B;AAoCA;EAAO,cAAA;AAjCP;AAyCM;EACE,kBAAA;EACA,wBAAA;AAvCR","sourcesContent":["\n\n.profile {\n    background-color: var(--body_background);\n    \n\n    .images {\n      width: 100%;\n      height: 300px;\n      position: relative;\n      \n\n      .cover {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n\n      .profilePic {\n        width: 200px;\n        height: 200px;\n        border-radius: 50%;\n        object-fit: cover;\n        position: absolute;\n        left: 0;\n        right: 0;\n        margin: auto;\n        top: 200px;\n      }\n    }\n    .profileContainer {\n      padding: 20px 70px;\n     \n\n      .uInfo {\n        height: 180px;\n        -webkit-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        -moz-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        border-radius: 20px;\n        background-color: var(--body_background);\n        color: var(--body_color);\n        padding: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 20px;\n\n      \n\n        \n\n        .center {\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 10px;\n\n          span {\n            font-size: 30px;\n            font-weight: 500;\n          }\n\n          .info {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: space-around;\n\n            .item {\n              display: flex;\n              align-items: center;\n              gap: 5px;\n              color: var(--body_color);\n\n              span {\n                font-size: 12px;\n              }\n            }\n          }\n\n          .toggleJobsAppliedTo{\n            padding: 10px;\n            border: none;\n            background-color: var(--body_color);\n            color: var(--body_background);\n            font-weight: bold;\n            cursor: pointer;\n\n          }\n          .myRequestsButton {\n            border: none;\n            background-color: var(--body_color);\n            color: var(--body_background);\n            cursor: pointer;\n            display: inline-block;\n            outline: 0;\n            padding: 0 56px;\n            height: 45px;\n            line-height: 45px;\n            border-radius: 7px;\n            background-color: turquoise;\n            font-weight: 400;\n            font-size: 16px;\n            box-shadow: 0 4px 14px 0 rgb(0 118 255 / 39%);\n            transition: background 0.2s ease,color 0.2s ease,box-shadow 0.2s ease;\n\n:hover{\n  background: rgba(0,118,255,0.9);\n  box-shadow: 0 6px 20px rgb(0 118 255 / 23%);\n}\n          }\n        \n          .recordedVideosButton{\n            border: none;\n            background-color: var(--body_color);\n            color: var(--body_background);\n            cursor: pointer;\n            display: inline-block;\n            outline: 0;\n            padding: 0 56px;\n            height: 45px;\n            line-height: 45px;\n            border-radius: 7px;\n            background-color: tourquoise;\n            font-weight: 400;\n            font-size: 16px;\n            box-shadow: 0 4px 14px 0 rgb(0 118 255 / 39%);\n            transition: background 0.2s ease,color 0.2s ease,box-shadow 0.2s ease;\n\n:hover{\n  background: rgba(0,118,255,0.9);\n  box-shadow: 0 6px 20px rgb(0 118 255 / 23%);\n}\n          }\n\n          .notificationsButton {\n             position: fixed;\n             top: 90px; \n            right: 20px; \n            background: none;\n            border: none;\n            padding: 5px;\n            cursor: pointer;\n\n            }\n\n          .notificationsButton img {\n            width: 30px; \n            height: auto;\n          }\n\n          .notificationCount {\n            position: absolute;\n            top: -5px; \n            right: -5px; \n            background-color: red;\n            color: white;\n            border-radius: 50%;\n            padding: 5px;\n            font-size: 12px;\n           }\n\n          .settingsbtn img{\n            width: 30px; \n            height: auto;\n          }\n   \n\n          .settingsbtn{\n            position: fixed;\n            top: 140px; \n           right: 20px; \n           background: none;\n           border: none;\n           padding: 5px;\n           cursor: pointer;\n          }\n\n          /* Dropdown button on hover & focus */\n\n\n/* The container <div> - needed to position the dropdown content */\n.dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n/* Dropdown Content (Hidden by Default) */\n.dropdown-content {\n  display: none;\n  position: fixed;\n  top: 200px; \n  right: 20px; \n  background-color: #f1f1f1;\n  min-width: 160px;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n  z-index: 1;\n}\n\n/* Links inside the dropdown */\n.dropdown-content a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n.profilePic{\n  justify-content: center;\n  align-items: center;\n}\n\n\n\n\n/* Change color of dropdown links on hover */\n.dropdown-content a:hover {background-color: #ddd;}\n\n/* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */\n.show {display:block;}\n       \n          }\n       \n      }\n      \n    }\n    .jobsAppliedToContainer{\n      h1{\n        text-align: center;\n        color: var(--body_color);\n      }\n\n    }\n\n    }  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
